import PropTypes from "prop-types";

/**
 * PropTypes for Notifications component
 *
 * @property {Array<Object>} [values] - Array of notification objects
 */
export const notificationsPropTypes = {
  values: PropTypes.arrayOf(
    PropTypes.shape({
      user: PropTypes.string,
      subject: PropTypes.string,
      date: PropTypes.string,
    })
  ),
};
